var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAvatarCircle = function SvgAvatarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 44c7.088 0 12.833-5.746 12.833-12.833 0-7.088-5.745-12.834-12.833-12.834S31.167 24.08 31.167 31.167C31.167 38.254 36.912 44 44 44Zm-15.583 3.667A6.417 6.417 0 0 0 22 54.083V55c0 4.388 2.791 8.099 6.756 10.621 3.986 2.537 9.38 4.046 15.244 4.046 5.864 0 11.258-1.51 15.244-4.046C63.208 63.1 66 59.388 66 55.001v-.918a6.417 6.417 0 0 0-6.417-6.416H28.417Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 84,
    height: 84,
    rx: 42,
    stroke: "currentColor",
    strokeWidth: 4
  })));
};

export { SvgAvatarCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODggODgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTQ0IDQ0QzUxLjA4NzYgNDQgNTYuODMzMyAzOC4yNTQzIDU2LjgzMzMgMzEuMTY2N0M1Ni44MzMzIDI0LjA3OSA1MS4wODc2IDE4LjMzMzQgNDQgMTguMzMzNEMzNi45MTIzIDE4LjMzMzQgMzEuMTY2NyAyNC4wNzkgMzEuMTY2NyAzMS4xNjY3QzMxLjE2NjcgMzguMjU0MyAzNi45MTIzIDQ0IDQ0IDQ0Wk0yOC40MTY3IDQ3LjY2NjZDMjQuODcyOCA0Ny42NjY2IDIxLjk5OTkgNTAuNTM5NiAyMiA1NC4wODM1TDIyIDU1LjAwMDFDMjIgNTkuMzg4MSAyNC43OTE1IDYzLjA5ODYgMjguNzU1NyA2NS42MjEzQzMyLjc0MTYgNjguMTU3OCAzOC4xMzYyIDY5LjY2NjcgNDMuOTk5OSA2OS42NjY3QzQ5Ljg2MzUgNjkuNjY2NyA1NS4yNTgyIDY4LjE1NzggNTkuMjQ0MiA2NS42MjEzQzYzLjIwODQgNjMuMDk4NiA2NiA1OS4zODgxIDY2IDU1LjAwMDFWNTQuMDgzM0M2NiA1MC41Mzk1IDYzLjEyNzIgNDcuNjY2NiA1OS41ODMzIDQ3LjY2NjZIMjguNDE2N1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICA8cmVjdCB4PSIyIiB5PSIyIiB3aWR0aD0iODQiIGhlaWdodD0iODQiIHJ4PSI0MiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNCIgLz4KPC9zdmc+CiAg";